import store from "src/Reducers/store";
import * as Types from "src/Constants/Types";

const setCurrentPage = (pageIndex: number) => store.dispatch({ type: Types.SET_CURRENT_PAGE as "SET_CURRENT_PAGE", value: pageIndex });

export default setCurrentPage;
